<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>青年實習培育</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div class="sectTit">打造東部青年人才實習培育基地</div>
        <br>
        <div class="left">
          製造業已非勞力密集的產業，大步走向「科技化」，和平電力作為台灣東部重點產業，長期需求機電、電子、化學材料、資訊控制等相關領域人才。近年積極與各大專院校合作，開放大三、大四、碩士生在學期間暑假到廠實習，學生可深入平常難以進入的電廠，了解運作實務、操作平時學校實驗室無法接觸到的分析儀器，將教科書的理論結合成務實的寶貴經驗。
        </div>
        <div class="right">
          <div class="salary">
            <div class="title">
              <psan class="txt1">實習期間</psan> <psan class="txt2">保障月薪</psan>
            </div>
            <div class="degree">
              <div class="item">
                <div class="tit">學士級<br>含勞健保</div>
                <div><i class="fa-solid fa-caret-down"></i></div>
                <div class="num1">30K</div>
              </div>
              <div class="item">
                <div class="tit">碩士級<br>含勞健保</div>
                <div><i class="fa-solid fa-caret-down"></i></div>
                <div class="num2">32K</div>
              </div>
              <div class="item">
                <div class="tit">畢業後留任<br>另發獎金</div>
                <div><i class="fa-solid fa-caret-down"></i></div>
                <div class="num3">20K</div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="gallery">
          <div class="left">
            <div class="imgContainer2-1"></div>
            <div class="imgContainer2-2"></div>
          </div>
          <div class="right">
            <div class="imgContainer2-3"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect4">
      <div class="ctx">
        <center>
          <div class="sectTit">培育青年永續人才 <span class="phoneBreak">台泥實習計畫</span></div>
        </center>
        <!-- <a class="fbLink" target="_blank" href="https://www.facebook.com/share/v/tL3LhU1yiB76Ta9L/"> -->
        <a class="fbLink" target="_blank" href="https://media.taiwancement.com/web_hppc/comm/2025%E6%9A%91%E6%9C%9F%E5%AF%A6%E7%BF%92%E7%94%9F%E7%B5%90%E6%A5%AD%E5%BC%8F%E5%BD%B1%E7%89%87.mp4">        
          <center><i class="fa-solid fa-circle-play"></i></center>
          <div>影片播放</div>
          <br>
          <img src="@/assets/joinPractice/pic4_01.jpg" />          
        </a>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <center>
          <div class="sectTit">學長姐分享</div>
        </center>
        <select class="yearSelect" v-model="practiceYear">
          <option v-for="year in getUniqueYears()" :key="year" :value="year">{{year}}</option>
        </select>
        <div class="yearSlider">
          <div v-for="year in getUniqueYears()" :key="year" :class="['btn', {'active': practiceYear === year}]" @click="switchPracticeYear(year)">{{year}}</div>
        </div>
        <div class="sectTag"><i class="fa-solid fa-ellipsis-vertical"></i><i class="fa-solid fa-ellipsis-vertical"></i> 回饋分享</div>
        <div class="practice">
          <template v-for="(row, idx) in practice" :key="idx">
            <div class="item" v-if="row.year === practiceYear || 0 === practiceYear">
              <div class="imgContainer3 thumbnail" :style="setPracticePic(row.thumbnail)">
              </div>
              <div class="info">
                <div class="left">
                  <div class="sign">#</div>
                </div>
                <div class="right">
                  <div class="tit">{{row.tit}}</div>
                  <div class="desp">
                    <p v-for="(row2, idx) in row.desp" :key="idx">{{row2}}</p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'JoinPractice',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      practiceYear: 0 as Number,
      practice: [
        {
          year: 2021,
          tit: "宜蘭大學 / 羅一哲",
          desp: [
            "在實習的過程中，我學習到了電廠大致上的製程方式、部分設備功能的運轉知識，以及了解到了平時例行巡視及設備維護的重要性。", 
            "至於畢業後會回到和電的原因是覺得這邊的工作氛圍跟自己的個性是蠻契合的，以及是份穩定的工作，如果有話需要我對學弟學妹說，那我會告訴他們：「對於未來的方向感到迷茫的話，不妨先到和電實習體驗體驗」。", 
          ],
          thumbnail: "pic3_01.jpg"
        },
        {
          year: 2021,
          tit: "花蓮高工 / 徐耀璟",
          desp: [
            "和平電廠為火力發電廠，是仰賴燃燒煤炭，產生蒸汽進而推動汽輪機產生機械動能，連結機械連軸設備產生力矩，推動發電機機組。故不論於發電設備或現場生產設備，皆為一般外界公司少見之生產設備項目，對於工安要求上更須嚴謹把關，對於不安全、不確定、不正確工作動作等都須避免發生。", 
            "實習期間，學習發電廠專業知識，瞭解目前全國發電廠供需平衡狀況及調節機制的概念。安全是工作中最重要的一環，一定要把握「想、檢查、提問、聯繫、溝通、確認」等原則。", 
          ],
          thumbnail: "pic3_02.jpg"
        },
        {
          year: 2021,
          tit: "宜蘭大學 / 徐靜如",
          desp: [
            "在和平電廠為期兩個月的實習中，我獲得了許多在課堂上無法接觸到的寶貴經驗，並深入理解電廠實務運作。實習初期，我曾擔心自己難以跟上進度，但透過實地參訪與專題研究，逐步建立了對整體系統的理解與應對能力。", 
            "每週的專題報告與預演中，指導人員會詳細指出錯誤並提供修正建議，幫助我在內容表達、邏輯組織及資料查證上都能持續進步，也讓我養成提前整理與驗證資料的習慣，對表達與專案執行力都有顯著提升。", 
            "我也非常欣賞和平電廠的團隊文化與工作氛圍。定期追蹤實習進度、同仁樂於協助，以及公平的工作分配，讓我能在平等與尊重的環境下專注學習。這段經歷不僅強化了我的專業技能，也加深了我對電力產業的認同與興趣，將成為我職涯發展中非常重要的一部分。"
          ],
          thumbnail: "pic3_03.jpg"
        },
        {
          year: 2022,
          tit: "宜蘭大學 / 吳珮禎",
          desp: [
            "過去對燃煤火力發電的認識多半來自課本與新聞報導，直到親自走進廠區，實際見到鍋爐、汽輪機與發電機如何環環相扣、穩定供電，我才真正理解電力系統背後的複雜運作與技術層次。",
            "我也實際接觸到空氣品質控制系統 (AQCS)，學習到 SCR 脫硝、ESP 靜電集塵器、FGD 脫硫等技術如何有效降低排放，顛覆了我過去對燃煤電廠的刻板印象。這讓我開始更關注空污的真實來源，理解電廠在環保上的努力與進步。此外，透過討論電價議題，我學會用更宏觀的角度分析能源政策。原來電價調整背後涉及能源進口、產業結構與公平性問題，而不是單純的「漲價與否」。這讓我體會到能源議題的複雜性與多面向。",
            "這段實習經驗不僅增進了我對發電技術的了解，也拓展了我對能源與環境議題的視野，並啟發了我獨立思考與深入探索的能力。"
          ],
          thumbnail: "pic3_04.jpg"
        },
        {
          year: 2023,
          tit: "宜蘭大學 / 王信昌",
          desp: [
            "我是機械系的，過去沒有接觸過電廠，藉由實習生計畫來到和平，發現在這裡看到許多在學校沒有接觸過的設備、專業儀器，畢業後想要更深入在這裡學得更多的經驗，因此選擇回到和平來任職，很多前輩也把課本學不到，實務操作手把手的傳授，是一個很好的工作。"
          ],
          thumbnail: "pic3_05.jpg"
        },
        {
          year: 2023,
          tit: "宜蘭大學 / 鍾楷駿",
          desp: [
            "實習期間我參與多項觀摩與操作活動，包括實地參訪發電機、水處理廠、煤倉等重要設備，並了解各廠區間的功能分工與相互支援的關係，以及感知器與控制器之間的訊號傳遞與應用機制等等，使我對工業控制有了初步的理解。儘管這些領域與我原先的知識有所差異，但帶給我許多全新的知識與啟發。",
            "和平電廠整體的職場氛圍亦令我印象深刻，主管與同仁們不吝於分享寶貴的實務經驗，也給予我參與部門討論與活動的機會，這樣的職場文化不僅有助於我專業能力的提升，也促進了我在人際互動與職場溝通上的成長。"
          ],
          thumbnail: "pic3_06.jpg"
        },
        {
          year: 2023,
          tit: "宜蘭大學 / 林寬衡",
          desp: [
            "初來乍到和平電廠，我分配到了儲運部，我們每天的例行工作分為早中晚三班，分別對輸煤及卸煤路線進行巡檢，在每日與學長一同到現場進行巡檢的過程中，逐步建立起對電廠系統的整體架構認知。透過與學長的討論與合作，有幸參予了和平電廠的霧化抑塵系統的規劃，在揚塵較為嚴重的頭輪與尾輪設置，讓噴頭向下噴出水霧，再由微米級的水霧碰撞到揚塵，從而達到抑塵的效果。",
            "在實習的這兩個月我不僅學到了專業知識，更培養了解決問題與溝通協調的能力，最後也是最重要的，在工作中如何保護自己，在電廠每項工具及設備都是相當危險的，如果每個人都保護好自己，就能大大減少事故發生的機率。這段經驗對我未來職涯規劃有深遠的意義。我所收穫的不單單只是簡單的兩個月薪水，在實習的這兩個月中，學到了很多都是讓我帶得走的知識與能力，期許能在未來就業時貢獻所學，同時持續精進自己。"
          ],
          thumbnail: "pic3_07.jpg"
        },
        {
          year: 2023,
          tit: "東華大學 / 黃少甫",
          desp: [
            "在我升上大四的那年暑假，我有幸參與和平電廠的暑期實習，這段寶貴的經歷讓我收穫良多，不僅拓展了專業知識，也加深了我對實務應用的理解。實習期間，我深入了解和平電廠的整體運作流程，並有機會參訪台泥企業團旗下其他子公司，對產業鏈的運作模式以及企業在永續發展方面的理念有了更全面的認識。同時，總公司也精心安排了許多寓教於樂的活動，讓我們在學習之餘能與來自不同學校、不同公司的實習生互動交流，建立了珍貴的人脈關係。更難能可貴的是，各部門的主管與工程師皆傾囊相授，無論在技術層面或職場態度上，都給予我們許多實用且深刻的指導，讓這次實習成為一段難得且充實的學習旅程。"
          ],
          thumbnail: "pic3_08.jpg"
        },
        {
          year: 2024,
          tit: "宜蘭大學 / 黃鈺傑",
          desp: [
            "2024 年 2 月至 6 月我在和平電力參與為期 4 個月的校外實習。實習初期，公司安排了新進員工教育訓練，並帶我們實地參觀廠區內的設施與設備，讓我能更快、更清楚地了解電廠的運作方式。深入認識和平電廠後，我了解到電廠及整個和平工業區的設計理念是循環利用，並且持續朝著環保方向進步。電廠內完善的環保設施，徹底改變了我對燃煤火力發電廠原有的負面印象。", 
            "我被分派到水務化驗組的除礦水廠實習，期間詳細學習了除礦水的製程，並測試各階段水中的離子成分。能夠將過去所學的知識實際應用於工作中，並在每月的成果報告中得到正向的鼓勵與回饋，讓我對自己的成長感到相當滿意。", 
            "回顧這段實習，最令我印象深刻的是，和平電廠有著清幽的地理環境、安全且整潔的工作環境，所有工作人員都盡忠職守，讓我感受不到過多的壓力。在和平電廠實習對我而言是一次難得的經驗，收穫遠超乎我的想像。"
          ],
          thumbnail: "pic3_09.jpg"
        },
        {
          year: 2024,
          tit: "宜蘭大學 / 紀彥廷",
          desp: [
            "和平電廠是我人生中第一次的實習經歷，也是在校園之外，首次近距離接觸到電廠這樣龐大且精密的運作體系。原本對電廠的想像是充滿機械轟鳴與油污的環境，然而親身走進和平電廠的那一刻，這些刻板印象全被顛覆了。廠內空間整潔有序，設施先進，令人驚艷的不僅是硬體條件，更是裡面那群默默付出、專業又親切的哥哥姐姐們。", 
            "在實習的每一天，他們不厭其煩地為我們解說專業知識，帶領我們了解電力的生成流程，甚至在工作之餘也會關心我們的生活與學習狀況。這份溫暖與包容，讓我在陌生的環境中感到踏實，也讓這段短暫卻充實的時光，成為我記憶中閃耀的一頁。", 
            "這次實習不只是知識與技能上的啟蒙，更讓我深深體會到，電力不僅是冰冷的能量流轉，它的背後是一群堅守崗位、默默耕耘的人們。和平電廠不僅開啟了我對專業領域的想像，也在我的成長旅途中，留下了深刻且難以磨滅的印記。"
          ],
          thumbnail: "pic3_10.jpg"
        },
        {
          year: 2024,
          tit: "宜蘭大學 / 張上文",
          desp: [
            "在和電實習期間，讓我對電廠的運作和電力系統有更完整的了解，透過各項培訓與現場實作，提升了我的專業技能與安全意識。同時學會與長官及不同部門之間溝通協調，體會到團隊合作的重要性。", 
            "這次實習讓我不僅獲得了技術上的成長，也在職業規劃和個人素養方面得到了啟發。帶著這些經驗，繼續努力深耕專業，追求在電力工程及綠能領域的長期發展。", 
            "我想給學弟妹們建議，在實習過程中我們會接觸到許多新知識與技術，一定要保持學習的心態，主動請教學長，不要害怕問問題，因為越是主動學習，越能快速掌握關鍵技能。"
          ],
          thumbnail: "pic3_11.jpg"
        },
        {
          year: 2024,
          tit: "台北科技大學 / 李鴻誠",
          desp: [
            "在和平電廠實習兩個月，是一段充實且有啟發性的經歷。實際參與電廠運作與設備維護，讓我對於電力系統的實務操作有了更深的理解，也親身感受到理論與實務之間的落差與結合的重要性。參與設備點檢流程，更逐漸建立起安全意識與現場判斷能力。", 
            "與工程師和技術人員的互動也讓我體會到團隊合作與即時溝通的重要性，而他們豐富的經驗與敬業態度，也成為我學習的榜樣。", 
            "這段時間我遇到了不少挑戰，像是對新設備不熟悉、操作環境複雜等，但每一次困難的克服都讓我獲得成長。"
          ],
          thumbnail: "pic3_12.jpg"
        },
        {
          year: 2024,
          tit: "台北科技大學 / 張益銘",
          desp: [
            "在和平電廠實習，讓我真正體會到「學以致用」。在儀控維修部的實習過程中，我實際參與了感測器、控制元件的檢查與維護，深入了解了電廠中 DCS、PLC、PID 控制等核心技術。每天都能看到這些大型系統如何穩定且高效地運作，讓我將課堂上所學的知識與實際應用成功連結起來。", 
            "實習中不只有收穫，還有很多感動。特別要感謝林振隆經理、副理與幾位學長，他們總是非常有耐心地指導我們。不僅在工作上手把手地教我們，也在下班後關心我們的生活起居，讓我們在異地也能感受到溫暖與歸屬感。", 
            "這段時間，讓我看見電力產業對台灣的重要性。發電與供電是國家正常運作不可或缺的一環，和平電廠在其中扮演了關鍵角色。",
            "我也因為這段實習，加深了對工業控制與電源管理的興趣。我開始更清楚知道自己未來想走的方向。我會持續往電源相關的領域發展，希望能在這方面做出貢獻。實習不只是履歷上的一筆經歷，更是一趟探索與成長的旅程。"
          ],
          thumbnail: "pic3_13.jpg"
        },
        {
          year: 2024,
          tit: "宜蘭大學 / 吳亞橦",
          desp: [
            "這是我第一次參加企業實習，心情既期待又緊張。雖然在學校學到了不少理論知識，但實際進入職場後才發現，現實中的工作內容和課堂上所學還是有些差距。學校的教育以基礎理論為主，而企業實習則更著重於實務操作與實際應用。這次實習的經驗讓我深刻體會到，光有理論知識是不夠的，還必須透過實際參與和操作，才能真正理解一項工作流程的來龍去脈。", 
            "在實習期間，我接觸到了許多過去未曾學過的系統與工具，也有機會觀察並參與整個工作團隊的運作。每當遇到不熟悉的設備時，部門的前輩們總是非常熱心地指導我們，耐心的替我們解說。這樣友善又願意分享的工作氛圍，讓我更願意主動學習。", 
            "這段時間的實習不僅增進了我的專業能力，也讓我對未來的職涯有了更清楚的方向。我學到的不只是工作技能，更重要的是工作態度與團隊合作的重要性。我也更有自信在未來面對職場的挑戰。能夠有這次實習機會，讓我收穫滿滿，我會將這段經歷當作一個重要的起點，繼續努力學習，提升自己。"
          ],
          thumbnail: "pic3_14.jpg"
        },
        {
          year: 2025,
          tit: "宜蘭大學 / 劉耿瑋",
          desp: [
            "在這次實習過程中，我深入了解了電廠各個機組的運作方式，特別是在水務化驗方面的實務操作。我參與了廢水處理場與除礦水場的巡檢與取樣工作，並進一步熟悉和平電廠的進水流程與相關處理機制。", 
            "本次實習的核心任務為水廠相關的專題研究，不僅能應用大學所學的專題實作技巧，也讓我接觸並學習到各式實驗設備的操作方式，有效提升了我的實驗能力與問題解決技巧。", 
            "給學弟妹的建議：如果你對未來方向尚未明確，不妨考慮到和平電廠實習。這裡不僅能學習到多樣的實驗器材操作，也能提早適應職場環境，累積寶貴的經驗。"
          ],
          thumbnail: "pic3_15.jpg"
        },
        {
          year: 2025,
          tit: "中原大學 / 鄭鈞鴻",
          desp: [
            "我來自中原大學，就讀於機械系在電廠裡的汽機部公用組實習，這四個月裡，透過電廠的同仁為我們實習生上課，預先了解其構造，之後分發部門時再實地走動把汽機房大致運行的原理了解清楚。", 
            "以前在學校裡只是紙上的字，理論無法跟實際有的東西做結合，透過實習期間的現場走動與機組大修，就讓我看到大型的旋轉機械怎麼透過液壓聯軸器來快速調整轉速，高壓蒸汽室怎麼防止洩漏等，然後與師傅學習馬達對心的經驗，其中的訣竅以及工具的使用。", 
            "很慶幸有這次實習來為我未來工作積累經驗，跟同事相處也了解到工作最重要的是保持著一顆學習新事物的心，而不是故步自封。"
          ],
          thumbnail: "pic3_16.jpg"
        },
        {
          year: 2025,
          tit: "文化大學 / 藍宸佑",
          desp: [
            "實習期間，我主要參與了變壓器的檢修與巡檢維護工作，深入了解了變壓器的檢修項目內容，例如絕緣油的檢測、接地系統檢查及溫度異常監測等，同時也學習了例行維護時需記錄的重要參數與變化值，如油溫度、高、低壓線圈溫度等，除了變壓器，我也有機會觀摩發電機的保養與維護流程，檢修的過程工程師或是現場的師傅，會告訴我檢修的原因或是其他我提出的疑問，幫助了我對變壓器跟發電機有更深的了解，透過實地參與與觀摩，我了解到這些電力設備的維護不僅是保障機組穩定運行的重要措施，也是確保整體電力系統安全與效率的關鍵。", 
            "在和平電廠實習期間，我感受到工作環境對安全與作業規範的高度重視，從每一次的工作前會議到實地操作，無不強調風險評估與標準流程。這段實習經歷讓我對電力產業有了更深入的理解，也讓我體會到電力維運工作的重要性與責任感，是一段非常有收穫的學習經驗。", 
          ],
          thumbnail: "pic3_17.jpg"
        },
        {
          year: 2025,
          tit: "宜蘭大學 / 周飛翔",
          desp: [
            "在暑期實習期間，我參與了電機維修部的輸電組、配電組與變電組的維修與巡檢，雖然無法實際去操作設備，但觀察實際運作、理解機組邏輯與安全標準，讓我收穫頗多也明顯感受到書本與現場的不同，課堂上學到的知識大多集中在理論與計算，例如變壓器的等效電路、三相不平衡計算、線損分析等等，但實際到了電廠現場才發現，真正影響運轉與安全的，往往不是理論，而是現場條件與人員經驗。", 
            "發電廠屬於高風險作業場所，所以電廠內有很多安全相關的規範以及措施，例如票房制度以及各種防誤觸措施，降低事故的風險。", 
            "和平電廠的工作氛圍、職員之間的互動都比較輕鬆，讓人很容易融入這個環境，想問問題也可以盡量問，大家都會熱心回答。這次實習讓我明白了一些電力工作的內容，也了解了很多關於安全方面的知識，讓我對自己的職涯方向多了點判斷依據。"
          ],
          thumbnail: "pic3_18.jpg"
        },
        {
          year: 2025,
          tit: "宜蘭大學 / 游于瑩",
          desp: [
            "和平電廠是我的第一份實習，從一開始的新進員工訓練課程、實際操作、每日的巡檢與操作協助中，使我對電廠的基本運作流程有了更深入的瞭解，除了變壓器、發電機的日常巡檢外，還學會了一些測量儀器的使用。", 
            "實習期間由多位學長帶我們認識設備、指導我們，他們都非常專業且用心，不管有任何的問題向他們提問都能得到非常詳細的解答，就算是不在他們的知識範圍也會替我們詢問到答案。", 
            "這段時間最讓我印象深刻的應該是這邊的工作氣氛，這邊的工作氣氛非常好，看到大家在路上碰到都會互相打趣地打招呼，大家也都很好相處，是我很喜歡的工作氣氛。",
            "在這段時間中真的收穫滿滿，不僅僅只是知識及技術，還有很多同事之間的相處，做事情的方式甚至是培養了我獨立思考的能力，這是一個非常棒的實習經驗。"
          ],
          thumbnail: "pic3_19.jpg"
        },
        {
          year: 2025,
          tit: "宜蘭大學 / 黃柏勝",
          desp: [
            "剛到和平的時候，我對電廠的運作其實不太熟悉，只知道這是個高壓且講求精準的地方，但隨著實習展開，開始理解整座電廠如何從燃料轉換為穩定的電力輸出，如何透過各系統間的協調，維持整體運作的安全與效率，在觀摩與教學中慢慢拼湊出整個流程的全貌。", 
            "有幾次跟著前輩巡檢現場，從設備運轉聲音的細微變化、壓力數值的起伏，到判斷可能的異常來源，讓我實際感受到「工程師的敏銳度」是如何在長時間的現場經驗中培養出來的，這是書本和模擬實驗中學不到的。", 
            "這段期間我也感受到團隊合作的重要，前輩們不吝指導，工作氛圍和諧有默契，讓我這樣初入現場的實習生也能放心學習，與我本身的個性相當契合，這次的實習讓我收穫的不只是技術，更是對工程現場的尊重與理解。"
          ],
          thumbnail: "pic3_20.jpg"
        },
        {
          year: 2025,
          tit: "宜蘭大學 / 余正丞",
          desp: [
            "在和平電廠鍋爐維修部的實習期間，我主要學習鍋爐相關設備的例行保養與巡檢流程，包含每週巡查鍋爐系統中的閥件與管路，觀察是否有滲漏、鬆動或磨損等異常情況，並了解後續處置與維修的處理方式。在維修技術人員與工程師的協助下，我逐漸熟悉各項現場作業流程，並藉由實際操作深入學習設備狀況的判讀方法與檢修工具的正確使用方式，對預防性維護的理念也有了更深層的體認。", 
            "和平電廠的工作環境專業、有條理，部門內氣氛融洽，前輩們對於實習生十分關照，無論在技術還是態度上都給予許多指導。這段實習經驗不僅加深了電廠設備維護的理解、實際體驗現場作業的複雜性與挑戰性，也讓我學會了在壓力下保持冷靜、確實完成任務，不僅累積了實務技能更將課堂所學成功應用於現場，對未來的學習歷程與專業素養都有深遠的助益。"
          ],
          thumbnail: "pic3_21.jpg"
        },
        {
          year: 2025,
          tit: "海洋大學 / 方俊斌",
          desp: [
            "我們儀控部的工作是檢測儀器、把壞掉的儀器修好能正常運轉，讓運操部能順利進行操作和使用這關係是環環相扣，目前學到滿多儀錶相關的維修，這讓我對電廠更加了解，尤其是鍋爐的部分，鍋爐有很多控制閥和氣動閥跟我們有很大的關係，像是水牆管破管偵測除灰器，冷風和熱風的氣動閥控制器，也有學到汽輪機儀器故障排除，尋找問題方法以及更換電磁流量計修理，另外再這次實習也有去總部學習一些課程，例如儲能系統應用與發展還有低碳建材介紹，這些是我以前不太關注的事情，但我藉由這次來到台泥企業團實習，更加了解台泥未來的發展，外出參訪時去了至善充電站、台北預拌廠，我印象最深刻是做水泥測試強度。"
          ],
          thumbnail: "pic3_22.jpg"
        },
        {
          year: 2025,
          tit: "海洋大學 / 李柏輝",
          desp: [
            "藉由此次實習，我深刻體會到課堂上學到的理論只是基礎，實際現場充滿許多突發狀況，必須臨機應變。正如前輩提醒我們：「慌張只會讓自己更危險，冷靜下來才能解決問題。」在實習期間，無論是部門學長姐、包商還是現場的老師傅們，都很樂意分享工作經驗與操作技巧，像是設備保養的細節、吹灰器軸封的鬆緊感等，甚至在安全允許下讓我們實際動手操作，增進理解。此外，電廠設備體積龐大，施工時更須嚴格遵循 SOP，如申請工作票等程序，以保障人員安全。這段實習不僅增進了我的專業技能，也讓我更重視安全與團隊合作的價值，衷心感謝所有指導與協助過我們的前輩，這段經驗將成為我日後職涯中寶貴的養分。"
          ],
          thumbnail: "pic3_23.jpg"
        },
        {
          year: 2026,
          tit: "楊宇丞",
          desp: [
            "這四個月的實習中，我了解火力發電廠的運作原理，以及身為一個化工人能在發電廠所扮演的角色。實習期間我完成了有關廢水處理的專題以及廢水檢測，過程中我面臨許多的困難以及挫折，但在化驗室的同事們不斷給我支持，陪我走完這段艱難的旅途，而我也藉由這次實習的機會增進了我研究及解決問題的能力，為後續的碩士班奠定基石。這次實習的機會也讓我能夠提前進入職場，讓我更加確定我所選擇的道路是正確的，在這裡實習四個月所學到的東西絕對比在學校用課本教的東西還要多。"
          ],
          thumbnail: "pic3_24.jpg"
        },
        {
          year: 2026,
          tit: "許廷睿",
          desp: [
            "在這次實習中，我最主要的工作就是在化驗室進行專題的研究，在研究的過程中不僅能將大學中學到的實驗技巧學以致用外，還能學習到用商業的角度來看待研究的工作，這是在校園中學不到的寶貴經驗。",
            "除了做專題研究外，職場的日常也讓我學到很多東西，透過電廠中許多前輩的分享與建議，讓我更了解自己想做的事與對於未來有更明確的方向。很開心我有機會來到和平電廠實習讓我累積工作經驗與學習新東西，讓我收穫滿滿，這段經驗一定能成為我未來成長的重要養分。"
          ],
          thumbnail: "pic3_25.jpg"
        }
      ]
    }
  },
  watch: {
    practiceYear: function() {
      this.$nextTick(() => {
        document.querySelectorAll(".imgContainer3").forEach( (elem) => {
          new ImgContainerAutoResize(elem as HTMLElement, 0.999);
        });
      });
    }
  },
  methods:{
    getUniqueYears() {
      const years = this.practice.map(item => item.year);
      const uniqueYears = [...new Set(years)];
      return uniqueYears.sort((a: number, b: number) => b - a);
    },
    switchPracticeYear(year: number) {
      this.practiceYear = year;
    },
    setPracticePic: function(file: string) {
      return {
        background: `url(${require(`@/assets/joinPractice/${file}`)})`,
        backgroundSize: "cover"
      }
    },
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 0.74);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-2") as HTMLElement, 0.74);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-3") as HTMLElement, 1);    

    setTimeout(() => {
      document.querySelectorAll(".imgContainer3").forEach( (elem) => {
        new ImgContainerAutoResize(elem as HTMLElement, 0.999);
      });

      this.practiceYear = this.getUniqueYears()[0];
    }, 50);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0, rgba(0, 0, 0, 0) 20%), url("@/assets/joinPractice/kv.webp");
  background-position: center, center bottom;
  background-size: cover, cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}
 
.sect1 .left {
  width: 47%;
  float: left;
  line-height: 2em;
}

.sect1 .right {
  width: 47%;
  float: right;
}

.sect1 .right .salary {
  overflow: hidden;
  border-radius: 30px;
}

.sect1 .right .salary .title {
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 24px;
  background: #CFEBE5;
}

.sect1 .right .salary .title .txt1 {
  color: #3077A8;
}

.sect1 .right .salary .title .txt2 {
  color: #E69876;
}

.sect1 .right .salary .degree {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  background: #fff;
}

.sect1 .right .salary .degree .item {
  flex: 0 0 33.33%;
  border-right: solid 1px #e0e0e0;
  text-align: center;
}

.sect1 .right .salary .degree .item .num1,
.sect1 .right .salary .degree .item .num2 {
  font-weight: 900;
  font-size: 40px;
  color: #63BFAA;
}

.sect1 .right .salary .degree .item .num3 {
  font-weight: 900;
  font-size: 40px;
  color: #E99776;
}

.sect2 {
  background: url(@/assets/joinPractice/sectBack2.png) center;
  background-size: cover;
}

.sect2 .gallery {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;
}

.sect2 .gallery .left {
  flex: 0 0 40%;
}

.sect2 .gallery .right {
  flex: 0 0 59.5%;
}

.sect2 .gallery .left .imgContainer2-1 {
  width: 100%;  
  background: url(@/assets/joinPractice/pic2_01.jpg) center;
  background-size: cover;
}

.sect2 .gallery .left .imgContainer2-2 {
  width: 100%;
  margin: 5px 0 0;
  background: url(@/assets/joinPractice/pic2_02.jpg) center;
  background-size: cover;
}

.sect2 .gallery .right .imgContainer2-3 {  
  width: 100%;
  background: url(@/assets/joinPractice/pic2_03.jpg) center;
  background-size: cover;
}

.sect3 {
}

.sect3 .sectTit {
  margin: 0 auto 40px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect3 .yearSelect {
  /* margin-left: auto; */
  /* margin-right: 0; */
  margin-bottom: 10px;
  padding: 5px 10px;
  box-sizing: border-box;
  display: none;
  border-radius: 5px;
  border: solid 1px #0C5F99;
  font-size: 16px;
  background: #fff;
}

.sect3 .yearSlider {
  position: relative;
  margin: 0 0 30px;
  display: flex;
  justify-content: center;
}

.sect3 .yearSlider .btn {
  width: 100px;
  height: 40px;
  margin: 0 5px;  
  line-height: 40px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  background: #0C5F9966;
  border-radius: 5px;  
  box-shadow: 2px 2px 5px #c0c0c0;
  cursor: pointer;
}

.sect3 .yearSlider .btn.active {
  background: #0C5F99;
  box-shadow: 2px 2px 5px #808080;
}

.sect3 .sectTag {
  padding: 7px 30px;
  box-sizing: border-box;
  display: inline-block;
  font-size: 20px;
  color: #fff;
  background: #E99776;
  box-shadow: 2px 2px 5px #808080;
}

.sect3 .practice {
  margin: -20px 0 0;
  padding: 40px;
  box-sizing: border-box;
  border-radius: 30px;
  background: #fff;
}

.sect3 .practice .item {
  width: 100%;
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-bottom: solid 1px #c0c0c0;
}

.sect3 .practice .item:last-child {
  border-bottom: none;
}

.sect3 .practice .item .thumbnail {
  height: 335px;
  flex: 0 0 30%;
}

.sect3 .practice .item .info {
  flex: 0 0 65%;
  display: flex;
  justify-content: space-between;
}

.sect3 .practice .item .info .left {
  flex: 0 0 40px;
}

.sect3 .practice .item .info .left .sign {
  line-height: 1em;
  font-family: arial;
  font-size: 52px;
  color: #E99776;
  transform: translateY(-10px);
}

.sect3 .practice .item .info .right {
  flex: 0 1 auto;
  line-height: 1.6em;
}

.sect3 .practice .item .info .right .tit {
  font-size: 20px;
  color: #0C5F99;
}

.sect3 .practice .item .info .right .desp {
  font-size: 16px;
}

.sect4 .sectTit {
  margin: 0 0 40px;
  padding: 5px 40px;
  box-sizing: border-box;
  display: inline-block;
  border: solid 1px #0C5F99;
  border-radius: 50px;
  font-weight: 700;
  font-size: 40px;
  color: #0C5F99;
}

.sect4 .fbLink {
  text-align: center;
  color: #0C5F99;
}

.sect4 .fbLink i {
  margin: 0 0 5px;
  font-size: 60px;
  transition: transform 0.5s;
}

.sect4 .fbLink i:hover {
  transform: scale(1.2);
}

.sect4 .fbLink img {
  width: 100%;
  display: block;
  vertical-align: bottom;
  transition: transform 0.5s;
}

.sect4 .fbLink img:hover {
  transform: scale(1.05);
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }  

  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 60%;
    margin: 20px 20% 0;
  }

  .sect3 .practice .item .thumbnail {
    height: 180px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .left {
    width: 100%;
  }

  .sect1 .right {
    width: 100%;
    margin: 20px 0 0;
  }

  .sect2 .sectTit {
    width: 320px;
    padding: 10px;
    top: -30px;
    font-size: 20px;
  }

  .sect2 .gallery .left {
    flex: 0 0 100%;
  }

  .sect2 .gallery .right {
    flex: 0 0 100%;
  }

  .sect2 .gallery .left .imgContainer2-2 {
    margin: 5px 0;
  }

  .sect3 .yearSelect {
    display: block;
  }

  .sect3 .yearSlider {
    display: none;
  }

  .sect3 .sectTit {
    width: 320px;
    font-size: 20px;
  }

  .sect3 .practice {
  padding: 20px;
  }

  .sect3 .practice .item .thumbnail {
    flex: 0 0 100%;
    height: auto
  }

  .sect3 .practice .item .info {
    flex: 0 0 100%;
    margin: 20px 0 0;
  }

  .sect4 .sectTit {
    font-size: 24px;
  }
}
</style>
